import { useLocalStorage } from 'usehooks-ts';

const SHIFT_EDIT_POLYGON_KEY = 'SHIFT_EDIT_POLYGON_KEY';
export const useLocalConfig = () => {
    const [useShiftForPolygonUpdate, setUseShiftForPolygonUpdate] = useLocalStorage<boolean>(
        SHIFT_EDIT_POLYGON_KEY,
        false
    );

    return { useShiftForPolygonUpdate, setUseShiftForPolygonUpdate };
};
